module.exports = "<app-nav></app-nav>\n<div class=\"padding-general\">\n  <app-content></app-content>\n</div>\n<app-footer></app-footer>"